module.exports = __webpack_public_path__ + "static/media/logo.aabc24fd.png";